import { Button, useMediaQuery, Stack } from "@mui/material";
import React, { useState } from "react";
import { colors } from "../../theme/theme";
import { ContinuousColorLegend } from "@mui/x-charts";

export const CustomCheckbox = ({
  options = [],
  selectedValues = [],
  onChange,
  multiple = false,
  noMb,
  noMt,
}) => {
  const smallScreen = useMediaQuery("(max-width:960px)");

  const handleSelection = (value) => {
    let updatedSelection;

    if (multiple) {
      // Toggle selection for multiple-choice
      updatedSelection = selectedValues.includes(value)
        ? selectedValues.filter((item) => item !== value)
        : [...selectedValues, value];
    } else {
      updatedSelection = [value];
    }

    onChange(updatedSelection);
  };

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={1}
      justifyContent="center"
      sx={{
        width: "100%",
      }}
    >
      {options.map((option) => (
        <Button
          key={option}
          sx={{
            mt: noMt ? 0 : 2,
            mb: noMb ? 0 : 2,
            flex: "1 1 30%",
            minWidth: "100px",
            height: "50px",
            backgroundColor: selectedValues.includes(option)
              ? "#FC0108"
              : "transparent",
            border: `1px solid ${
              selectedValues.includes(option) ? "#FC0108" : "#000"
            }`,
            color: selectedValues.includes(option) ? "#fff" : "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textTransform: "none",
            borderRadius: "0px", // Removed border-radius
            "&:hover": {
              backgroundColor: smallScreen ? "" : "#FC1018",
              color: smallScreen ? "" : "#fff",
            },
            fontFamily: "Inter-SemiBold",
            fontSize: smallScreen ? "14px" : "16px",
          }}
          onClick={(e) => {
            handleSelection(option);
          }}
        >
          {option}
        </Button>
      ))}
    </Stack>
  );
};
